"use client";

import type { FC } from "react";
import { NextImage } from "@/src/components/NextImage";
import { RESULT_CHART_ASSETS } from "./resultChartAssets";

interface ResultPayoffBannerProps {
  title: string;
  body: string;
}

export const ResultPayoffBanner: FC<ResultPayoffBannerProps> = ({
  title,
  body,
}) => (
  <div
    className="flex w-full items-center gap-3 bg-background_accent3_overlay10 px-3.5 py-3"
    data-testid="result-payoff-banner"
  >
    <NextImage
      src={RESULT_CHART_ASSETS.shared.payoffSparkle}
      alt=""
      width={26}
      height={26}
      className="size-6.5 shrink-0"
    />
    <div className="flex min-w-0 flex-1 flex-col gap-1">
      <p className="title_l text-content_accent3_primary">{title}</p>
      <p className="body_m text-content_secondary">{body}</p>
    </div>
  </div>
);
